var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0625 4.80005V5.61255H6V7.23755H6.8125V17.8C6.8125 18.231 6.9837 18.6444 7.28845 18.9491C7.5932 19.2538 8.00652 19.425 8.4375 19.425H16.5625C16.9935 19.425 17.4068 19.2538 17.7115 18.9491C18.0163 18.6444 18.1875 18.231 18.1875 17.8V7.23755H19V5.61255H14.9375V4.80005H10.0625ZM10.0625 8.86255H11.6875V16.175H10.0625V8.86255ZM13.3125 8.86255H14.9375V16.175H13.3125V8.86255Z",
    fill: "#667080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.97b643eb9a6d32d8066538df98cb9390.svg";
export { ForwardRef as ReactComponent };